import Navbar from '../../components/Navbar'
import Footer from '../Home/components/Footer'
import { connect } from 'react-redux'
import setRedirectUrl from '../../redux/actions/redirection/setRedirectUrl'
import setLogged from '../../redux/actions/logged/setLogged'
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  TextField,
  useMediaQuery,
  useTheme
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useContext, useState, useEffect, useCallback } from 'react'
import { TenantsContext } from '../../context/tenants.context'
import {
  deleteAnuncio,
  getAnunciantes,
  getAnunciosABM,
  getDetalleAnuncio,
  getTiposAnuncio
} from './services/services.anuncios'
import { defaultPaginatorRes, PaginatorRes } from '../Pedidos/context/pedidos.context'
import TablaAnuncios from './componentes/TablaAnuncios'
import { AnuncioDTO, IAnunciante, ITipoAnuncio } from './types/anuncios.types'
import CardsAnuncios from './componentes/CardsAnuncios'
import FormAnuncio from './widgets/formAnuncio'
import SnackBarUtils from '../../utils/SnackBarUtils'
import DictionaryItem from '../../dto/DictionaryDTO'
import { getTiposCuenta } from '../../components/AdminLocal/services/admin.local.services'
import useRubros from '../Products/hooks/rubros.hook'
import ConfirmDialog from '../Products/components/ConfirmDialog'
import { INITIAL_ROWS_PER_PAGE } from '../Products/components/TableDataPagination'

export interface FiltrosAnuncios {
  idAnunciante: number
  idAnuncioTipo: number
  soloActivos: boolean
  pagina: number
  pageSize: number
}

const defaultFiltrosAnuncios = {
  idAnunciante: null,
  idAnuncioTipo: null,
  soloActivos: true,
  pagina: 0,
  pageSize: INITIAL_ROWS_PER_PAGE
}

const AbmAnuncios = (props: any) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [search, setSearch] = useState<boolean>(false)
  const [filtros, setFiltros] = useState<FiltrosAnuncios>(defaultFiltrosAnuncios)
  const [paginator, setPaginator] = useState<PaginatorRes>(defaultPaginatorRes)
  const [anuncios, setAnuncios] = useState<AnuncioDTO[]>([])
  const [soloActivos, setSoloActivos] = useState<boolean>(true)
  const [tiposAnuncio, setTiposAnuncio] = useState<ITipoAnuncio[]>([])
  const [accountTypes, setAccountTypes] = useState<DictionaryItem[]>([])
  const [anunciantes, setAnunciantes] = useState<IAnunciante[]>([])
  const [selectedAnuncio, setSelectedAnuncio] = useState<AnuncioDTO>(null)
  const [submit, setSubmit] = useState<boolean>(true)
  const [openForm, setOpenForm] = useState<boolean>(false)
  const { tenant } = useContext(TenantsContext)
  const { flatRubros } = useRubros()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [confirmDialog, setConfirmDialog] = useState<any>({
    open: false,
    text: {
      title: '',
      body: '',
      leftButton: 'Cancelar',
      rightButton: 'Confirmar',
      colorButtonConfirm: 'primary'
    },
    action: async () => {}
  })

  const clearConfirmDialog = () => {
    setConfirmDialog((confirmDialog: any) => ({
      ...confirmDialog,
      open: false
    }))
  }

  paginator.handleChangePage = (e: any, newPage: number) => {
    setFiltros((filtros) => ({
      ...filtros,
      pagina: newPage
    }))
    setPaginator({ ...paginator, pageNumber: newPage - 1 })
    setSubmit(true)
  }

  paginator.handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const newPageSize = parseInt(event.target.value, 10)
    setFiltros((filtros) => ({
      ...filtros,
      pageSize: newPageSize,
      pagina: 0
    }))
    setPaginator({ ...paginator, pageSize: newPageSize, pageNumber: 0 })
    setSubmit(true)
  }

  const fetchTiposCuenta = useCallback(() => {
    if (accountTypes.length !== 0) return
    getTiposCuenta(tenant)
      .then((result) => {
        setAccountTypes(result.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [tenant])

  const fetchDetalleAnuncio = useCallback(
    async (idAnuncio: number) => {
      try {
        setLoading(true)
        getDetalleAnuncio(tenant, idAnuncio).then((res) => {
          setSelectedAnuncio(res?.data.data)
        })
        fetchTiposCuenta()
        setOpenForm(true)
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    },
    [tenant]
  )

  const handleDelete = useCallback(
    async (idAnuncio: number) => {
      setConfirmDialog({
        open: true,
        text: {
          title: 'Eliminar anuncio',
          body: '¿Desea eliminar este anuncio?',
          leftButton: 'Cancelar',
          rightButton: 'Confirmar',
          colorButtonConfirm: 'error'
        },
        action: async () => {
          deleteAnuncio(tenant, idAnuncio)
            .catch((e) => {
              console.log(e)
              SnackBarUtils.error(e.message === 'Network Error' ? 'Ocurrió un error al eliminar el anuncio' : e.message)
            })
            .then(() => {
              SnackBarUtils.error('Anuncio eliminado')
              setSubmit(true)
            })
            .finally(() => {
              setLoading(false)
              clearConfirmDialog()
            })
        },
        close: () => {
          setLoading(false)
          clearConfirmDialog()
        }
      })
    },
    [tenant]
  )

  const handleSubmit = useCallback(async () => {
    //if (!filtros?.idAnunciante && !filtros?.idAnuncioTipo) return
    try {
      setLoading(true)
      setSearch(true)
      await getAnunciosABM(tenant, filtros).then((res) => {
        setAnuncios(res?.data.data)
        setPaginator({
          ...paginator,
          pageNumber: res?.data.pageNumber,
          pageSize: res?.data.pageSize,
          hasNextPage: res?.data.hasNextPage,
          totalRecord: res?.data.totalRecord
        })
      })
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
      setSubmit(false)
    }
  }, [tenant, filtros])

  const fetchTiposAnuncio = useCallback(async () => {
    try {
      setLoading(true)
      await getTiposAnuncio(tenant).then((res) => setTiposAnuncio(res.data.data))
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }, [tenant])

  const fetchAnunciantes = useCallback(async () => {
    try {
      setLoading(true)
      await getAnunciantes(tenant).then((res) => setAnunciantes(res.data.data))
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }, [tenant])

  useEffect(() => {
    fetchTiposAnuncio()
    fetchAnunciantes()
  }, [tenant])

  useEffect(() => {
    submit && handleSubmit()
  }, [filtros, submit])

  if (!tiposAnuncio || !anunciantes) return

  return (
    <>
      <Navbar title="ABM Anuncios" />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          padding: '10px',
          backgroundColor: '#f5f5f5',
          borderRadius: '5px',
          marginBottom: '1rem',
          marginTop: '0.6rem',
          gap: '0.6rem',

          // display column en mobile
          '@media (max-width: 768px)': {
            flexDirection: 'column',
            gap: '5px'
          }
        }}
      >
        <FormControl sx={{ flex: 1 }}>
          <Autocomplete
            options={anunciantes}
            getOptionLabel={(a) => a.nombre || ''}
            onChange={(e: any) => {
              setFiltros({
                ...filtros,
                idAnunciante: anunciantes.find((a) => a.idAnunciante === e.target.value)?.idAnunciante || null,
                pagina: 0
              })
            }}
            disabled={loading}
            value={anunciantes?.find((a) => a.idAnunciante === filtros?.idAnunciante) || null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Anunciante"
                onKeyDown={(e) => e.key === 'Enter' && filtros && setSubmit(true)}
                placeholder="Todos"
                variant="outlined"
              />
            )}
            renderOption={(props, a: { idAnunciante: number; idLocal: number; nombre: string }) => (
              <MenuItem {...props} value={a.idAnunciante} key={a.idAnunciante}>
                {`${a.nombre} (${a.idLocal})`}
              </MenuItem>
            )}
          />
        </FormControl>
        <FormControl sx={{ flex: 1 }}>
          <Autocomplete
            options={tiposAnuncio}
            getOptionLabel={(tipo) => tipo.nombre || ''}
            onChange={(e: any) => {
              setFiltros({
                ...filtros,
                idAnuncioTipo: tiposAnuncio.find((tipo) => tipo.id === e.target.value)?.id || null,
                pagina: 0
              })
            }}
            disabled={loading}
            value={tiposAnuncio?.find((tipo) => tipo.id === filtros?.idAnuncioTipo) || null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tipos de anuncio"
                onKeyDown={(e) => e.key === 'Enter' && filtros && setSubmit(true)}
                placeholder="Todos"
                variant="outlined"
              />
            )}
            renderOption={(props, tipo: { id: number; nombre: string }) => (
              <MenuItem {...props} value={tipo.id} key={tipo.id}>
                {tipo.nombre}
              </MenuItem>
            )}
          />
        </FormControl>
        <FormControl
          disabled={loading}
          sx={{
            flex: '0 0 auto',
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap'
          }}
        >
          <FormControlLabel
            sx={{ flex: 1 }}
            control={
              <Checkbox
                checked={soloActivos}
                onChange={(e) => {
                  setSoloActivos(e.target.checked)
                  setFiltros({ ...filtros, soloActivos: e.target.checked, pagina: 0 })
                }}
              />
            }
            label="Sólo activos"
          />
        </FormControl>
        <FormControl
          sx={{
            paddingRight: '10px',
            '@media (max-width: 768px)': {
              width: '100%'
            }
          }}
        >
          <Button
            disabled={loading}
            variant="contained"
            onClick={() => filtros && setSubmit(true)}
            sx={{
              height: '50px',
              '@media (max-width: 768px)': {
                display: 'flex',
                gap: '10px'
              }
            }}
          >
            <Box
              sx={{
                display: 'none',
                '@media (max-width: 768px)': {
                  display: 'block'
                }
              }}
            >
              Filtrar
            </Box>
            <SearchIcon style={{ margin: 0 }} />
          </Button>
        </FormControl>
        <Button
          disabled={loading}
          sx={{ height: '50px', flex: 1 }}
          variant="contained"
          color="success"
          onClick={() => {
            fetchTiposCuenta()
            setOpenForm(true)
          }}
        >
          Crear Anuncio
        </Button>
      </Box>
      {isMobile ? (
        <CardsAnuncios
          loading={loading}
          anuncios={anuncios}
          paginator={paginator}
          tiposAnucio={tiposAnuncio}
          anunciantes={anunciantes}
          searching={search}
          handleUpdate={fetchDetalleAnuncio}
          handleDelete={handleDelete}
        />
      ) : (
        <TablaAnuncios
          loading={loading}
          anuncios={anuncios}
          paginator={paginator}
          tiposAnucio={tiposAnuncio}
          anunciantes={anunciantes}
          searching={search}
          handleUpdate={fetchDetalleAnuncio}
          handleDelete={handleDelete}
        />
      )}
      <FormAnuncio
        open={openForm}
        setOpen={setOpenForm}
        anunciantes={anunciantes}
        tiposAnuncio={tiposAnuncio}
        rubros={flatRubros}
        accountTypes={accountTypes}
        anuncio={selectedAnuncio}
        setAnuncio={setSelectedAnuncio}
        setSubmit={setSubmit}
        isMobile={isMobile}
      />
      <Footer />
      <ConfirmDialog {...confirmDialog} />
    </>
  )
}

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
    theme: state.theme,
    toaster: state.toaster,
    redirection: state.redirection
  }
}

const mapDispatchToProps = {
  setRedirectUrl,
  setLogged
}

export default connect(mapStateToProps, mapDispatchToProps)(AbmAnuncios)
